import { useEffect, useState } from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';
import { useAtom } from 'jotai';
import { Icon, Text } from '@pairy/pds-react';

import useUpdateViewerPageState from '../../../../../hooks/useUpdateViewerPageState';
import { isDisableHelpersAtom } from '../../../../../store/index.atom';

import * as Styled from './index.styles';

export interface Props {
  totalPage: number;
  openDrawer: () => void;
  ctaFormPage?: number;
  isMoveCtaFormPageRequirements?: boolean;
  isMobileLandscape: boolean;
}

interface Inputs {
  currentPage: number;
}

const MobilePageIndicator = ({
  totalPage,
  ctaFormPage,
  openDrawer,
  isMoveCtaFormPageRequirements,
  isMobileLandscape,
}: Props) => {
  const [isDisableHelpers, setIsDisableHelpers] = useAtom(isDisableHelpersAtom);

  const { updateCurrentPage, currentPage } = useUpdateViewerPageState();

  const [isEditable, setIsEditable] = useState(false);
  const { handleSubmit, register, setFocus, setValue, getValues } =
    useForm<Inputs>();

  useEffect(() => {
    if (!isEditable) {
      setValue('currentPage', currentPage);
    }
  }, [currentPage, isEditable, setValue]);

  const changeCurrentPage = () => {
    const value = getValues('currentPage');

    /*유저가 폼을 제출하지 않은 채 다른 페이지로 이동하려고 할 때 
    폼이 있는 페이지로 이동 시킨다 */
    if (totalPage && value >= 1 && value <= totalPage) {
      if (
        ctaFormPage &&
        isMoveCtaFormPageRequirements &&
        Number(value) >= ctaFormPage
      ) {
        updateCurrentPage(ctaFormPage);
      } else {
        updateCurrentPage(Number(value));
      }
    }

    setIsEditable(false);
  };

  const onSubmit: SubmitHandler<Inputs> = () => {
    changeCurrentPage();
  };

  useEffect(() => {
    setIsEditable(false);
  }, [isDisableHelpers, setIsEditable]);

  useEffect(() => {
    if (isDisableHelpers) {
      changeCurrentPage();
    }
  }, [isDisableHelpers]);

  useEffect(() => {
    if (isEditable) {
      setFocus('currentPage');
    }
  }, [isEditable, setFocus]);

  return (
    <Styled.StackWrapper
      className={isDisableHelpers ? 'disable' : ''}
      alignItems="center"
      gap={8}
      isMobileLandscape={isMobileLandscape}
    >
      <Icon
        icon="ph:list-dashes"
        size={19}
        onClick={(e) => {
          e.stopPropagation();

          if (isDisableHelpers) {
            setIsDisableHelpers(false);
            return;
          }

          openDrawer();
        }}
        color="black"
      />
      {isEditable ? (
        <form onSubmit={handleSubmit(onSubmit)}>
          <Styled.Input
            type="number"
            {...register('currentPage', {
              value: currentPage,
            })}
          />
        </form>
      ) : (
        <Styled.FlexCurrentPageTextWrapper
          alignContent="center"
          justifyContent="center"
          onClick={(e) => {
            e.stopPropagation();
            setIsDisableHelpers(false);
            setIsEditable(true);
          }}
        >
          <Text variant="sm-medium" color="black" lineHeight="15px">
            {currentPage}
          </Text>
        </Styled.FlexCurrentPageTextWrapper>
      )}
    </Styled.StackWrapper>
  );
};

export default MobilePageIndicator;
